import React from "react";
import { Modal, Button } from "antd";
import { BasicUrl } from "config/config";
import "../../userCommon.css";

const CatiModal = ({ visible, onClose }) => {
  const host = window.location.hostname;
  console.log(host);
  // const hrefhost =
  //   host === "test-front-base.survey.work" || host === "localhost"
  //     ? "http://test.base.survey.work"
  //     : "http://survey.work";
  // console.log(hrefhost);
  const hrefhost = BasicUrl[process.env.REACT_APP_CURRENT];
  const handleOk = () => {
    window.open(`${hrefhost}/catiPhone`);
    onClose(false);
  };
  const handleCancel = () => {
    onClose(false);
  };
  return (
    <Modal
      title=""
      width={800}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          onClick={() => {
            onClose(false);
          }}
        >
          关闭弹窗
        </Button>
      ]}
    >
      <div className="catibox">
        <div className="catileft">
          <div className="catitit">CATI云电话查询</div>
          <div className="caticont">
            云端CATI电话调查，在线自动拨号，多坐席管理，通话状态跟踪，全过程录音
          </div>
          <ul>
            <li>在线自动拨号：调查APP在线自动拨号，对外显示固定座机号</li>
            <li>多坐席高效率：多个调查员可同时开展工作，便捷高效</li>
            <li>通话状态跟踪：呼叫通话状态实时掌握，历史数据协助管理统计</li>
            <li>通话全程录音：每份调查实时、全程录音，审核更便捷</li>
          </ul>
          <a href={`${hrefhost}/catiPhone`} target="_blank">
            {`查看CATI云电话调查 功能详情>`}
          </a>
        </div>
        <div className="catiright">
          <div className="catiimgcont">打开微信，扫码联系开通</div>
          <img className="catiimg" src="/img/code.png" alt="" />
        </div>
      </div>
    </Modal>
  );
};

export default CatiModal;
